<template>
  <div style="width: 350px;margin:40px auto; ">
    <el-form :model="formData" label-width="90px">
      <el-form-item label="授权code">
        <el-input v-model="formData.code" placeholder="微信公众号登录授权code" readonly/>
      </el-form-item>
      <el-form-item label="微信openid">
        <el-input v-model="formData.openid" placeholder="微信公众号openid" readonly/>
      </el-form-item>
      <el-form-item label="绑定账号">
        <el-input v-model="formData.user_name"/>
      </el-form-item>
      <el-form-item label="登录密码">
        <el-input v-model="formData.password" type="password"/>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="bindUser">绑定</el-button>
        <el-button @click="unBind">解除绑定</el-button>
      </el-form-item>
    </el-form>
  </div>

</template>

<script>
import {getParam} from 'joysun-frame'

export default {
  name: "BindUser.vue",
  inject: ['$fn'],
  data() {
    return {
      formData: {
        "code": "",
        "openid": "",
        "user_name": "",
        "full_name": "",
        "password": ""
      }
    }
  },
  methods: {
    //获取绑定信息
    async getBindInfo() {
      this.formData = await this.$http('wxService.getBindInfo', this.formData);
    },
    async bindUser() {
      await this.$http('wxService.bindUserBySelf', this.formData);
      this.$message.success("绑定成功");
      this.formData.password = '';
    },
    async unBind() {
      await this.$http('wxService.unbindBySelf', this.formData);
      this.$message.success("解除成功");
      this.formData.user_name = '';
      this.formData.password = '';
    }
  },
  mounted() {
    this.formData.code = getParam('code');
    this.getBindInfo()
  }
}
</script>

<style scoped>

</style>